<script lang="ts" setup>
import SkrButton from '@/components/button/SkrButton.vue'
import BaseDialog from '@/components/dialogs/BaseDialog.vue'

const emit = defineEmits<{
  close: []
}>()

const { t } = useI18n()

const identShopUrl = useIdentShopUrl()
</script>

<template>
  <base-dialog
    :title="t('signature_standards.increase.advanced.no_valid_eid.title')"
    data-cy="eid_not_found_dialog"
    @close="emit('close')"
  >
    <v-row class="py-10">
      <div class="text-pre-wrap">
        <i18n-t
          keypath="signature_standards.increase.advanced.no_valid_eid.description.text"
          tag="div"
          for="signature_standards.increase.advanced.no_valid_eid.description.link_text"
        >
          <a :href="identShopUrl" target="_blank" rel="noopener">{{
            t('signature_standards.increase.advanced.no_valid_eid.description.link_text')
          }}</a>
        </i18n-t>
      </div>
    </v-row>
    <template #actions>
      <skr-divider />
      <div class="d-flex justify-end py-4 px-7">
        <skr-button size="xl" data-cy="dialog_action_button" @click="emit('close')">
          {{ t('signature_standards.increase.advanced.no_valid_eid.action_cta') }}
        </skr-button>
      </div>
    </template>
  </base-dialog>
</template>
